import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { HashRouter } from 'react-router-dom';
import './App.css';
import ScrollToTop from "./Components/Scroll";
import { Home, Cources, Contact, About, UnderConstruction, BlogPage, AllBlog, CoursesPreview } from "./Pages/ExportPages";
import { useEffect, useState, useContext } from 'react';
import "aos/dist/aos.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
// Review Image
import Rabin from "./Photos/Review/Rabin.png";
import Rajesh from "./Photos/Review/Rajesh.png";
import Anish from "./Photos/Review/Anish.jpg";

// Blogs Image
import bishal from "./Photos/Blogs/Bishal.jpg";
import bhanu from "./Photos/Review/bhanu.jpg"

// Course Image
import graphicDesign from "./Photos/Courses/Courses1.png"
import uiux from "./Photos/Courses/Course2.png"
import web from "./Photos/Courses/Courses3.png"
import video from "./Photos/Courses/Course4.png"
import ccnaTraining from "./Photos/Courses/Course5.jpeg"

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // duration in ms
  }, []);
  const [scrollY, setScrollY] = useState(0);

  const handleScroll = () => {
    setScrollY(window.scrollY || document.documentElement.scrollTop);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    // Cleanup to remove listener when component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [fullNav, setFullNav] = useState(true)
  useEffect(() => {
    scrollY > 400 ? setFullNav(false) : setFullNav(true)
  }, [scrollY]);




  const Reviews = [
    {
      desc: "Scaleup Academy in Pokhara provides hands-on courses and mentorship to help turn creative passions into professional careers.",
      name: "Rabin Poudel",
      post: "Senior Video Editor",
      image: Rabin
    },
    {
      desc: "Untitled transformed how we manage projects—faster, smarter, and more collaborative than ever.",
      name: "Anish Bhandari",
      post: "Student",
      image: Anish
    },
    {
      desc: "Scaleup Academy empowers learners in Pokhara with hands-on creative and tech skills practical, job-ready, and guided by expert mentors.",
      name: "Rajesh Dhakal",
      post: "Student",
      image: Rajesh
    }
  ]

  const CoursesDetails = [
    {
      courseId: "1",
      title: "Graphic Design",
      desc: "Unlock your creativity with design fundamentals to advanced branding.",
      largeDesc: [
        "This course offers a comprehensive introduction to visual communication, combining design theory, software instruction, project-based learning, and portfolio building. You’ll explore how to use tools like Adobe Photoshop, Illustrator, and Figma to craft impactful visuals for print and digital media. By the end of the program, you’ll possess the skills and confidence to start working in branding, multimedia, web design, and creative roles.",
        "Our curriculum is researched, developed, and updated by understanding the global scope and job demands. Conducted by industry-leading expert instructors, the program offers more than 85% of an in-depth practical approach backed by essential theoretical frameworks."
      ],
      whatNext: {
        title: "What You Can Do After This Course",
        listDesc: [
          "Work as a Graphic Designer or Visual Communicator in creative agencies or companies.",
          "Design logos, branding packages, posters, and social media visuals.",
          "Start freelancing projects on platforms like Fiverr, Upwork, or Freelancer.",
          "Work on marketing campaigns, product packaging, and print/digital advertisements.",
          "Pursue further specialization in UI/UX or Motion Graphics and More."
        ]
      },
      courseType: ["2.5 Months"],
      courseDescType: [
        {
          courseTitle: "2.5 Months",
          title: "6 Day a week (Sunday - Friday)",
          classTime: ["Morning", "Day", "Evening"]
        }
      ],
      img: graphicDesign,
      instructorName: "Bhanubhakta Sapkota",
      instructorTag: "@thevisualdesigner",
      instructorImg: "",
      blg: "Graphic Design Masterclass"
    },
    {
      courseId: "2",
      title: "UI/UX Design",
      desc: "Unlock your creativity with design fundamentals to advanced branding.",
      largeDesc: [
        "The UI/UX Design Course immerses learners into the full product design lifecycle — from user research, wireframing, and prototyping to usability testing and visual design. You’ll master Figma, Adobe XD, and modern design systems while learning to create intuitive, engaging, and accessible digital experiences for web and mobile platforms.",
        "Our curriculum is researched, developed, and updated to match the global demand for skilled UI/UX designers. Conducted by expert mentors, this course focuses on hands-on learning with real projects and design case studies."
      ],
      whatNext: {
        title: "What You Can Do After This Course",
        listDesc: [
          "Start your career as a UI/UX Designer or Product Designer.",
          "Design user-centered interfaces for apps, websites, and software.",
          "Work in startups, tech companies, or freelance globally.",
          "Create interactive prototypes and conduct usability testing.",
          "Develop a professional design portfolio to showcase your skills."
        ]
      },
      courseType: ["2.5 Months"],
      courseDescType: [
        {
          courseTitle: "2.5 Months",
          title: "6 Day a week (Sunday - Friday)",
          classTime: ["Morning", "Day", "Evening"]
        }
      ],
      img: uiux,
      instructorName: "Bhanubhakta Sapkota",
      instructorTag: "@thevisualdesigner",
      instructorImg: "",
      blg: "Graphic Design Masterclass"
    },
    {
      courseId: "3",
      title: "Digital Marketing",
      desc: "Unlock your creativity with design fundamentals to advanced branding.",
      largeDesc: [
        "The Digital Marketing Course is designed to help you master the latest online marketing tools and techniques. You’ll learn about SEO, social media, paid advertising, content strategy, and data-driven campaigns that help businesses grow online. This course focuses on hands-on learning through live campaigns, analytics tools, and real-world case studies.",
        "Our curriculum is regularly updated to reflect evolving digital trends and employer expectations. With guidance from experienced marketing professionals, you’ll build strategies that drive measurable results."
      ],
      whatNext: {
        title: "What You Can Do After This Course",
        listDesc: [
          "Work as a Digital Marketing Executive, Social Media Manager, or SEO Specialist.",
          "Manage and grow online presence for brands and businesses.",
          "Plan and execute advertising campaigns on platforms like Google Ads, Meta, and TikTok.",
          "Start your freelance digital marketing journey or work with agencies.",
          "Build and analyze digital reports using tools like Google Analytics."
        ]
      },
      courseType: ["2.5 Months"],
      courseDescType: [
        {
          courseTitle: "2.5 Months",
          title: "6 Day a week (Sunday - Friday)",
          classTime: ["Morning", "Day", "Evening"]
        }
      ],
      img: web,
      instructorName: "Bhanubhakta Sapkota",
      instructorTag: "@thevisualdesigner",
      instructorImg: "",
      blg: "Marketing Course"
    },
    {
      courseId: "4",
      title: "Video Editing",
      desc: "Unlock your creativity with design fundamentals to advanced branding.",
      largeDesc: [
        "The Video Editing Course equips you with the creative and technical skills needed to produce professional-quality videos. You’ll gain expertise in tools such as Adobe Premiere Pro, After Effects, and Filmora, while exploring editing workflows, color correction, sound design, and motion graphics. Through project-based assignments, you’ll create short films, reels, ads, and promotional videos ready for your portfolio.",
        "Our curriculum emphasizes hands-on, practical training conducted by experienced editors and content creators. You’ll also learn about the latest AI-driven editing tools and techniques shaping the modern video industry."
      ],
      whatNext: {
        title: "What You Can Do After This Course",
        listDesc: [
          "Work as a Video Editor, Motion Graphic Artist, or Content Creator.",
          "Edit YouTube videos, social media reels, and corporate films.",
          "Collaborate with brands, agencies, or production houses.",
          "Start freelancing or build your own content creation portfolio.",
          "Use AI and automation tools to enhance editing workflows."
        ]
      },
      courseType: ["2.5 Months"],
      courseDescType: [
        {
          courseTitle: "2.5 Months",
          title: "6 Day a week (Sunday - Friday)",
          classTime: ["Morning", "Day", "Evening"]
        }
      ],
      img: video,
      instructorName: "Bhanubhakta Sapkota",
      instructorTag: "@thevisualdesigner",
      instructorImg: "",
      blg: "Marketing Course"
    },
    {
      courseId: "5",
      title: "CCNA Training",
      desc: "Master networking fundamentals, routing, switching, and IT infrastructure with practical labs and real-world training.",
      largeDesc: [
        "The CCNA Training Program at Scaleup Academy is designed for students, beginners, and aspiring IT professionals who want to build a strong foundation in networking and IT infrastructure. This course covers networking fundamentals, routing, switching, IP addressing, network security, WiFi infrastructure, and real-world networking environments through practical learning and hands-on labs.",
        "You’ll learn how modern networks work and gain industry-oriented skills required for careers in networking, cybersecurity, cloud infrastructure, and technical support."
      ],
      whatNext: {
        title: "What You Can Do After This Course",
        listDesc: [
          "Work as a Network Support Technician or IT Support Associate.",
          "Configure routers, switches, and troubleshoot networking issues.",
          "Start freelancing or consulting in networking projects.",
          "Work in IT infrastructure, cybersecurity, or cloud networking roles.",
          "Pursue advanced certifications like CCNP or specialization in cybersecurity."
        ]
      },
      courseType: ["2.5 Months"],
      courseDescType: [
        {
          courseTitle: "2.5 Months",
          title: "6 Day a week (Sunday - Friday)",
          classTime: ["Morning", "Day", "Evening"]
        }
      ],
      img: ccnaTraining,
      instructorName: "Instructor Name Here",
      instructorTag: "@networkingexpert",
      instructorImg: "",
      blg: "CCNA Training Program",

      // Extra Sections
      skillsLearn: [
        "Networking Fundamentals",
        "IP Addressing & Subnetting",
        "Routers & Switching",
        "Network Configuration",
        "WiFi & IT Infrastructure",
        "Network Security Basics",
        "Troubleshooting & Diagnostics",
        "Cisco Networking Concepts",
        "Practical Lab Configuration",
        "Real-World Networking Workflow"
      ],
      benefits: [
        "Build strong networking fundamentals",
        "Learn through practical lab sessions",
        "Understand real-world IT infrastructure",
        "Beginner-friendly learning environment",
        "Industry-oriented networking skills",
        "Prepare for future IT & networking careers"
      ],
      academyBenefits: [
        "Industry-Experienced Trainers",
        "Practical Hands-on Labs & Real Equipment",
        "Affordable Training Cost",
        "Internship Opportunity & Career Guidance",
        "Real-World Networking Environment",
        "Flexible Class Shifts",
        "Project-Based Practical Learning",
        "Supportive Learning Environment"
      ],
      whoCanJoin: [
        "Students",
        "Beginners in IT",
        "+2 Graduates",
        "BIT / BCA / CSIT Students",
        "Non-Tech Learners Interested in IT",
        "Future Networking & Cybersecurity Professionals"
      ]
    }

  ]

  const blgCourse = [
    {
      name: "Web Development (MERN Stack)",
      for: "Beginner-Advance",
      desc: "The Ultimate Graphic Design Course Which Covers Photoshop, Illustrator InDesign, Design Theory, Branding, Logo Design",
      type: ["Online", "Physical", "2.5 month"],
      teacher: bishal,
      teacherName: "Bishal Dhakal",
      tagName: "@codewithbishal",
      crs: web
    }
  ]

  const Blogs = [
    {
      "website": {
        "id": 1,
        "date": "9 Nov 2025",
        "title": "Best IT & Tech Courses in Pokhara | Scaleup Academy",
        "catogery": "Graphic Design",
        "name": "Scaleup Academy",
        "tagline": "Skillup with Scaleup Academy, Master the Future",
        "meta": {
          "title": "Best IT & Tech Courses in Pokhara | Scaleup Academy",
          "description": "Join the best Graphic Design, UI/UX, Web Development, and Digital Marketing courses in Pokhara, Nepal — by Bhanu Bhakta Sapkota (TheVisualDesigner). Build a creative and tech-driven career today."
        },
        "author": {
          "name": "Bhanu Bhakta Sapkota",
          "alias": "thevisualdesigner",
          image: bhanu,
          "knowledge": "Graphics Designer || UI/UX Designer || Mentor",
          "site": "www.thevisualdesigner.com",
          "email": "itsbhanu2022@gmail.com",
          "social": [
            {
              "name": "facebook",
              "link": "www.facebook.com"
            },
            {
              "name": "pintetrest",
              "link": "www.facebook.com"
            },
            {
              "name": "youtube",
              "link": "www.facebook.com"
            },
            {
              "name": "instagram",
              "link": "www.facebook.com"
            },
          ],
        },
        "courseDesc": {
          "title": "Master the Future: Best it / tech courses in pokhara"
        },
        "location": "Pokhara, Nepal",
        "heroSection": {
          "heading": "Learn Skills That Shape the Future",
          "subheading": "Empowering creativity and technology through practical learning.",
          "backgroundNote": "Use a wide hero banner showing students learning design and coding with overlay text: 'Learn Skills That Shape the Future.'"
        },
        "introduction": {
          "heading": "Introduction",
          "content": [
            "In a world where technology and creativity drive every successful brand, skills likeGraphic Design, UI/UX Design, Web Development, and Digital Marketing have becomeindispensable. Businesses-whether startups or large enterprises-need professionalswho can visually communicate, design seamless experiences, develop high-performingwebsites, and reach the right audience online.",
            "At Scaleup Academy Pokhara, we empower students to transform their passion fordesign and technology into a rewarding career. Our hands-on, project-based courseshelp you learn industry-standard tools, gain practical experience, and prepare for bothlocal and global opportunities.",
            "# Design Note: Use a wide hero banner showing students learning design and codingwith overlay text: “Learn Skills That Shape the Future."
          ]
        },

        "courses": [
          {
            "title": "Graphic Design",
            "sections": [
              {
                "title": "Graphic Design",
                "content": [
                  "Graphic design is the art and practice of creating visual content that communicates messages with clarity and impact. It involves the strategic use of typography, color, layout, and imagery to shape how people perceive brands, information, and ideas. From social media posts to product packaging, graphic design influences nearly every visual interaction we see in the modern world.",
                  "In today’s digital era, businesses rely heavily on visuals to stand out. Whether it's a startup in Pokhara, an e-commerce store in Nepal, or an international brand, design determines how a company communicates and competes. Strong design helps.",
                ],
                "lists": {
                  "title": "",
                  "ul": [
                  ],
                  "ending": ""
                }
              },
              {
                "title": "Career & Future Scope in Graphic Design",
                "content": [
                  "In Nepal, junior graphic designers may earn NPR 15,000-30,000/month; mid-level NPR30,000-45,000; senior roles over NPR 45,000 + per month. Specialising in UI/UX or motiongraphics further increases value. The demand for remote designers is rising. Platforms likeUpwork, Fiverr, and Behance create global earning opportunities regardless of location.",
                  "As freelancing and global clients rise, earnings can go much higher."
                ],
                "lists": {
                  "title": "",
                  "ul": [
                  ],
                  "ending": ""
                }
              },
              {
                "title": "Why Learn Graphic Design at Scaleup Academy?",
                "content": [
                  "Scaleup Academy focuses on practical, portfolio-driven learning that prepares you for real projects from day one. Our expert-led training—guided by professionals like our expert mentors with real industry experience (our creative industry professionals)—helps you master:",
                  "We emphasize hands-on tasks so you graduate with a portfolio strong enough toimpress clients and employers.",
                ],
                "lists": {
                  "title": "",
                  "ul": [
                  ],
                  "ending": ""
                }
              }
            ]
          },
          {
            "title": "UI/UX Design",
            "sections": [
              {
                "title": "UI/UX Design",
                "content": [
                  "UI/UX Design is the process of creating user-friendly, visually appealing, and meaningful digital experiences. UI (User Interface) focuses on look and layout, while UX (User Experience) ensures that apps and websites are easy to use, intuitive, and enjoyable. Together, they shape how users interact with digital products. Better user experience leads to higher engagement, more sales, and improved customer satisfaction. As businesses in Nepal shift toward digital platforms, UI/UX has become essential.",
                  "UI designers create the graphical portions of mobile apps, websites, and devices—the elements that a user directly interacts with. Unlike UX, which can apply to just about any product or service, the term UI design applies exclusively to digital products. A UI designer seeks to make apps and websites both visually appealing and easy to navigate. Common tasks of a UI designer include:",
                  "In Nepal: UI/UX designers earn NPR 50,000–100,000+, with opportunities in fintech, SaaS companies, and digital products.",
                  "Globally: Remote UI/UX designers are in high demand, with international freelanceplatforms offering competitive project-based earnings",
                  "At Scaleup Academy, you learn through hands-on, practical projects guided byexpert mentors with real industry experience. You graduate with a completeportfolio of UI/UX case studies ready for employment or freelancing.",
                ],
                "lists": {
                  "title": "",
                  "ul": [
                  ],
                  "ending": ""
                }
              },
              {
                "title": "Career & Future Scope in Graphic Design",
                "content": [
                  "In Nepal, junior graphic designers may earn NPR 15,000-30,000/month; mid-level NPR30,000-45,000; senior roles over NPR 45,000 + per month. Specialising in UI/UX or motiongraphics further increases value. The demand for remote designers is rising. Platforms likeUpwork, Fiverr, and Behance create global earning opportunities regardless of location.",
                  "As freelancing and global clients rise, earnings can go much higher."
                ],
                "lists": {
                  "title": "",
                  "ul": [
                  ],
                  "ending": ""
                }
              },
              {
                "title": "Why Learn Graphic Design at Scaleup Academy?",
                "content": [
                  "Scaleup Academy focuses on practical, portfolio-driven learning that prepares you for real projects from day one. Our expert-led training—guided by professionals like our expert mentors with real industry experience (our creative industry professionals)—helps you master:",
                  "We emphasize hands-on tasks so you graduate with a portfolio strong enough toimpress clients and employers.",

                ],
                "lists": {
                  "title": "",
                  "ul": [
                  ],
                  "ending": ""
                }
              },

            ]
          },
          {
            "title": "Web Development",
            "sections": [
              {
                "title": "Web Development",
                "content": [
                  "Web Development is the process of building websites and web applications that peopleuse daily. It includes frontend development (design & visuals users interact with) andbackend development (servers, logic, and databases that power the system). Together,they create functional, interactive, and responsive digital platforms.",
                  "Every business-from retail shops to hospitals-needs a modern website to operate andgrow. With digital transformation increasing in Nepal, web development has become atop career choice. Companies rely on developers to create fast, secure, and visuallyappealing websites",
                  "In Nepal: Developers earn NPR 25,000-80,000+, with higher potential for full-stackdevelopers and those working with modern frameworks.",
                  "Globally: Remote development jobs and international freelance projects offer strongincome potential, even from Nepal",
                  "At Scaleup Academy, you learn through hands-on, practical projects guided byexpert mentors with real industry experience. You graduate with a completeportfolio of UI/UX case studies ready for employment or freelancing.",
                ],
                "lists": {
                  "title": "At Scaleup Academy we offer project-based learning guided by experienced industryprofessionals. You learn",
                  "ul": [
                    "HTML, CSS, JavaScript, React or Vue",
                    "Backend: Node.js, PHP, Laravel",
                    "Databases, hosting & deployment",
                    "Git/GitHub & best coding practices"
                  ],
                  "ending": "By the end, you will have real websites and full-stack projects added to your professional portfolio."
                },
              },

              // {
              //   "title": "Career & Future Scope in Graphic Design",
              //   "content": [
              //     "In Nepal, junior graphic designers may earn NPR 15,000-30,000/month; mid-level NPR30,000-45,000; senior roles over NPR 45,000 + per month. Specialising in UI/UX or motiongraphics further increases value. The demand for remote designers is rising. Platforms likeUpwork, Fiverr, and Behance create global earning opportunities regardless of location.",
              //     "As freelancing and global clients rise, earnings can go much higher."
              //   ]
              // },
              // {
              //   "title": "Why Learn Graphic Design at Scaleup Academy?",
              //   "content": [
              //     "Scaleup Academy focuses on practical, portfolio-driven learning that prepares you for real projects from day one. Our expert-led training—guided by professionals like our expert mentors with real industry experience (our creative industry professionals)—helps you master:",
              //     "We emphasize hands-on tasks so you graduate with a portfolio strong enough toimpress clients and employers.",

              //   ]
              // }
            ]
          },
          {
            "title": "Digital Marketing",
            "sections": [
              {
                "title": "Digital Marketing",
                "content": [
                  "Digital Marketing is the strategy and practice of promoting products and services through online platforms such as Google, Facebook, Instagram, TikTok, websites, and email. It uses analytics, content, paid ads, and SEO to help brands reach the right audience.",
                  "As businesses shift to online operations, digital marketing has become essential for visibility and growth. Companies require skilled marketers who understand how to generate leads, run ad campaigns, optimize SEO, and analyze performance.",
                  "In Nepal: Digital marketers earn NPR 20,000–100,000+, depending on skill level, specialization, and results delivered.",
                  "Globally: Freelancers and remote digital marketers can work with international brands, earning significantly more.",
                ],
                "lists": {
                  "title": "At Scaleup Academy, you learn from expert mentors with real campaign experience.You’ll master:",
                  "ul": [
                    "SEO & content marketing",
                    "Social media strategy (FB, Instagram, TikTok, LinkedIn and more)",
                    "Meta Ads & Google Ads",
                    "Analytics & conversion tracking",
                    "Building full marketing funnels"
                  ],
                  "ending": "You graduate ready to work in agencies, companies, or as a freelancer"
                }
              },

            ],


          },
        ]

        ,
        "whyScaleupAcademy": {
          "heading": "Why Learn at Scaleup Academy, Pokhara",
          "points": [
            "Hybrid Learning: Morning, day, and evening classes (online & onsite).",
            "Practical, project-based learning approach.",
            "Expert mentors from creative and tech industries.",
            "Portfolio development for job and freelance readiness.",
            "Internship, freelancing mentorship, and job placement support.",
            "Community & networking opportunities in Pokhara."
          ],
          "designNote": "Include carousel showcasing different course banners and student experiences."
        },
        "cta": {
          "heading": "Ready to turn your creativity and tech passion into a professional career?",
          "text": "Join the Best Graphic Design, UI/UX, Web Development, and Digital Marketing Courses in Pokhara, Nepal at Scaleup Academy today!",
          "button": "Join Course"
        }
      }
    },
    {
      "website": {
        "id": 2,
        "date": "10 Nov 2025",
        "title": "Content Creation Course in Pokhara – Scaleup Academy ",
        "catogery": "Content Creation",
        "name": "Scaleup Academy",
        "tagline": "Content Creation Course in Pokhara – Scaleup Academy ",
        "meta": {
          "title": "Content Creation Course in Pokhara – Scaleup Academy ",
          "description": " Learn content creation in Pokhara with Scaleup Academy. Build skills in writing, social media, SEO, and storytelling to boost your career in digital marketing and design. "
        },
        "author": {
          "name": "Rabin Paudel",
          "alias": "travelwithrabu",
          image: Rabin,
          "knowledge": "Backend Developer | Video Editor",
          "site": "",
          "email": "itsrabu@gmail.com"
        },
        "courseDesc": {
          "title": "Content Creation Course in Pokhara – Scaleup Academy"
        },
        "location": "Pokhara, Nepal",
        "heroSection": {
          "heading": "Learn Skills That Shape the Future",
          "subheading": "Empowering creativity and technology through practical learning.",
          "backgroundNote": "Use a wide hero banner showing students learning design and coding with overlay text: 'Learn Skills That Shape the Future.'"
        },
        "introduction": {
          "heading": "Introduction",
          "content": [
            "In today’s digital world, content is king. Every brand relies on engaging content to connect with audiences. Whether it’s blogs, social media posts, emails, or marketing campaigns, content creation skills are essential. At Scaleup Academy Pokhara, we help students master content creation, combining creativity with technical expertise.",
          ]
        },

        "courses": [
          {
            "title": "Graphic Design",
            "sections": [
              {
                "title": "",
                "content": [
                  // "Graphic design is the art and practice of creating visual content that communicates messages with clarity and impact. It involves the strategic use of typography, color, layout, and imagery to shape how people perceive brands, information, and ideas. From social media posts to product packaging, graphic design influences nearly every visual interaction we see in the modern world.",
                  // "In today’s digital era, businesses rely heavily on visuals to stand out. Whether it's a startup in Pokhara, an e-commerce store in Nepal, or an international brand, design determines how a company communicates and competes. Strong design helps.",
                ],
                "lists": {
                  "title": "Why Content Creation is Important:",
                  "ul": [
                    "Craft stories that resonate",
                    "Design visuals that attract attention",
                    "Drive engagement and conversions",
                  ],
                  "ending": ""
                }
              },
              {
                "title": "",
                "content": [
                  // "In Nepal, junior graphic designers may earn NPR 15,000-30,000/month; mid-level NPR30,000-45,000; senior roles over NPR 45,000 + per month. Specialising in UI/UX or motiongraphics further increases value. The demand for remote designers is rising. Platforms likeUpwork, Fiverr, and Behance create global earning opportunities regardless of location.",
                  // "As freelancing and global clients rise, earnings can go much higher."
                ],
                "lists": {
                  "title": "Career Opportunities in Content Creation:",
                  "ul": [
                    "Nepal: NPR 20,000-60,000/month for beginners, more for experienced freelancers",
                    "Global: Remote work via Upwork, Fiverr, and agencies",
                  ],
                  "ending": ""
                }
              },
              {
                "title": "",
                "content": [
                  // "Scaleup Academy focuses on practical, portfolio-driven learning that prepares you for real projects from day one. Our expert-led training—guided by professionals like our expert mentors with real industry experience (our creative industry professionals)—helps you master:",
                  // "We emphasize hands-on tasks so you graduate with a portfolio strong enough toimpress clients and employers.",
                ],
                "lists": {
                  "title": "Course Highlights / What You Learn:",
                  "ul": [
                    "SEO-friendly writing & blogging",
                    "Social media content strategy: FB, Instagram, TikTok, LinkedIn",
                    "Visual content creation basics",
                    "Email marketing & newsletters",
                    "Analytics & engagement measurement",
                  ],
                  "ending": ""
                }
              }
            ]
          },
          {
            "title": "UI/UX Design",
            "sections": [
              {
                "title": "",
                "content": [
                  // "UI/UX Design is the process of creating user-friendly, visually appealing, and meaningful digital experiences. UI (User Interface) focuses on look and layout, while UX (User Experience) ensures that apps and websites are easy to use, intuitive, and enjoyable. Together, they shape how users interact with digital products. Better user experience leads to higher engagement, more sales, and improved customer satisfaction. As businesses in Nepal shift toward digital platforms, UI/UX has become essential.",
                  // "UI designers create the graphical portions of mobile apps, websites, and devices—the elements that a user directly interacts with. Unlike UX, which can apply to just about any product or service, the term UI design applies exclusively to digital products. A UI designer seeks to make apps and websites both visually appealing and easy to navigate. Common tasks of a UI designer include:",
                  // "In Nepal: UI/UX designers earn NPR 50,000–100,000+, with opportunities in fintech, SaaS companies, and digital products.",
                  // "Globally: Remote UI/UX designers are in high demand, with international freelanceplatforms offering competitive project-based earnings",
                  // "At Scaleup Academy, you learn through hands-on, practical projects guided byexpert mentors with real industry experience. You graduate with a completeportfolio of UI/UX case studies ready for employment or freelancing.",
                ],
                "lists": {
                  "title": "Why Learn at Scaleup Academy:",
                  "ul": [
                    "Hybrid classes (online & onsite)",
                    "Expert mentors with industry experience",
                    "Portfolio development",
                    "Internship, freelancing & career guidance"
                  ],
                  "ending": ""
                }
              },
              // {
              //   "title": "Career & Future Scope in Graphic Design",
              //   "content": [
              //     "In Nepal, junior graphic designers may earn NPR 15,000-30,000/month; mid-level NPR30,000-45,000; senior roles over NPR 45,000 + per month. Specialising in UI/UX or motiongraphics further increases value. The demand for remote designers is rising. Platforms likeUpwork, Fiverr, and Behance create global earning opportunities regardless of location.",
              //     "As freelancing and global clients rise, earnings can go much higher."
              //   ],
              //   "lists": {
              //     "title": "",
              //     "ul": [
              //     ],
              //     "ending": ""
              //   }
              // },
              // {
              //   "title": "Why Learn Graphic Design at Scaleup Academy?",
              //   "content": [
              //     "Scaleup Academy focuses on practical, portfolio-driven learning that prepares you for real projects from day one. Our expert-led training—guided by professionals like our expert mentors with real industry experience (our creative industry professionals)—helps you master:",
              //     "We emphasize hands-on tasks so you graduate with a portfolio strong enough toimpress clients and employers.",

              //   ],
              //   "lists": {
              //     "title": "",
              //     "ul": [
              //     ],
              //     "ending": ""
              //   }
              // },

            ]
          },
          // {
          //   "title": "Web Development",
          //   "sections": [
          //     {
          //       "title": "Web Development",
          //       "content": [
          //         "Web Development is the process of building websites and web applications that peopleuse daily. It includes frontend development (design & visuals users interact with) andbackend development (servers, logic, and databases that power the system). Together,they create functional, interactive, and responsive digital platforms.",
          //         "Every business-from retail shops to hospitals-needs a modern website to operate andgrow. With digital transformation increasing in Nepal, web development has become atop career choice. Companies rely on developers to create fast, secure, and visuallyappealing websites",
          //         "In Nepal: Developers earn NPR 25,000-80,000+, with higher potential for full-stackdevelopers and those working with modern frameworks.",
          //         "Globally: Remote development jobs and international freelance projects offer strongincome potential, even from Nepal",
          //         "At Scaleup Academy, you learn through hands-on, practical projects guided byexpert mentors with real industry experience. You graduate with a completeportfolio of UI/UX case studies ready for employment or freelancing.",
          //       ],
          //       "lists": {
          //         "title": "At Scaleup Academy we offer project-based learning guided by experienced industryprofessionals. You learn",
          //         "ul": [
          //           "HTML, CSS, JavaScript, React or Vue",
          //           "Backend: Node.js, PHP, Laravel",
          //           "Databases, hosting & deployment",
          //           "Git/GitHub & best coding practices"
          //         ],
          //         "ending": "By the end, you will have real websites and full-stack projects added to your professional portfolio."
          //       },
          //     },

          //     // {
          //     //   "title": "Career & Future Scope in Graphic Design",
          //     //   "content": [
          //     //     "In Nepal, junior graphic designers may earn NPR 15,000-30,000/month; mid-level NPR30,000-45,000; senior roles over NPR 45,000 + per month. Specialising in UI/UX or motiongraphics further increases value. The demand for remote designers is rising. Platforms likeUpwork, Fiverr, and Behance create global earning opportunities regardless of location.",
          //     //     "As freelancing and global clients rise, earnings can go much higher."
          //     //   ]
          //     // },
          //     // {
          //     //   "title": "Why Learn Graphic Design at Scaleup Academy?",
          //     //   "content": [
          //     //     "Scaleup Academy focuses on practical, portfolio-driven learning that prepares you for real projects from day one. Our expert-led training—guided by professionals like our expert mentors with real industry experience (our creative industry professionals)—helps you master:",
          //     //     "We emphasize hands-on tasks so you graduate with a portfolio strong enough toimpress clients and employers.",

          //     //   ]
          //     // }
          //   ]
          // },
          // {
          //   "title": "Digital Marketing",
          //   "sections": [
          //     {
          //       "title": "Digital Marketing",
          //       "content": [
          //         "Digital Marketing is the strategy and practice of promoting products and services through online platforms such as Google, Facebook, Instagram, TikTok, websites, and email. It uses analytics, content, paid ads, and SEO to help brands reach the right audience.",
          //         "As businesses shift to online operations, digital marketing has become essential for visibility and growth. Companies require skilled marketers who understand how to generate leads, run ad campaigns, optimize SEO, and analyze performance.",
          //         "In Nepal: Digital marketers earn NPR 20,000–100,000+, depending on skill level, specialization, and results delivered.",
          //         "Globally: Freelancers and remote digital marketers can work with international brands, earning significantly more.",
          //       ],
          //       "lists": {
          //         "title": "At Scaleup Academy, you learn from expert mentors with real campaign experience.You’ll master:",
          //         "ul": [
          //           "SEO & content marketing",
          //           "Social media strategy (FB, Instagram, TikTok, LinkedIn and more)",
          //           "Meta Ads & Google Ads",
          //           "Analytics & conversion tracking",
          //           "Building full marketing funnels"
          //         ],
          //         "ending": "You graduate ready to work in agencies, companies, or as a freelancer"
          //       }
          //     },

          //   ],


          // },
        ]

        ,
        "whyScaleupAcademy": {
          "heading": "Why Learn at Scaleup Academy, Pokhara",
          "points": [
            "Hybrid Learning: Morning, day, and evening classes (online & onsite).",
            "Practical, project-based learning approach.",
            "Expert mentors from creative and tech industries.",
            "Portfolio development for job and freelance readiness.",
            "Internship, freelancing mentorship, and job placement support.",
            "Community & networking opportunities in Pokhara."
          ],
          "designNote": "Include carousel showcasing different course banners and student experiences."
        },
        "cta": {
          "heading": "Ready to turn your creativity and tech passion into a professional career?",
          "text": "Join the Best Graphic Design, UI/UX, Web Development, and Digital Marketing Courses in Pokhara, Nepal at Scaleup Academy today!",
          "button": "Join Course"
        }
      }
    },
    {
      "website": {
        "id": 3,
        "date": "11 Nov 2025",
        "title": "Learn Video Editing in Pokhara | Scaleup Academy",
        "catogery": "Video Editing",
        "name": "Scaleup Academy",
        "tagline": " Learn Video Editing in Pokhara | Scaleup Academy ",
        "meta": {
          "title": " Learn Video Editing in Pokhara | Scaleup Academy ",
          "description": " Master video editing in Pokhara with Scaleup Academy. Learn Adobe Premiere, After Effects, storytelling, and post-production skills for professional growth."
        },
        "author": {
          "name": "Rabin Paudel",
          "alias": "travelwithrabu",
          image: Rabin,
          "knowledge": "Backend Developer | Video Editor",
          "site": "",
          "email": "itsrabu@gmail.com"
        },
        "courseDesc": {
          "title": "Learn Video Editing in Pokhara | Scaleup Academy"
        },
        "location": "Pokhara, Nepal",
        "heroSection": {
          "heading": "Learn Skills That Shape the Future",
          "subheading": "Empowering creativity and technology through practical learning.",
          "backgroundNote": "Use a wide hero banner showing students learning design and coding with overlay text: 'Learn Skills That Shape the Future.'"
        },
        "introduction": {
          "heading": "Introduction",
          "content": [
            "Videos dominate digital platforms. Skilled video editors turn raw footage into professional, engaging content. Scaleup Academy Pokhara offers a hands-on video editing course teaching storytelling, motion graphics, and industry-standard tools.",
          ]
        },

        "courses": [
          {
            "title": "Graphic Design",
            "sections": [
              {
                "title": "",
                "content": [
                  // "Graphic design is the art and practice of creating visual content that communicates messages with clarity and impact. It involves the strategic use of typography, color, layout, and imagery to shape how people perceive brands, information, and ideas. From social media posts to product packaging, graphic design influences nearly every visual interaction we see in the modern world.",
                  // "In today’s digital era, businesses rely heavily on visuals to stand out. Whether it's a startup in Pokhara, an e-commerce store in Nepal, or an international brand, design determines how a company communicates and competes. Strong design helps.",
                ],
                "lists": {
                  "title": "Why Video Editing Skills Matter:",
                  "ul": [
                    "Boost brand engagement",
                    "Improve social media and marketing campaigns",
                    "Create professional content for YouTube, TikTok, and Instagram",
                  ],
                  "ending": ""
                }
              },
              {
                "title": "",
                "content": [
                  // "In Nepal, junior graphic designers may earn NPR 15,000-30,000/month; mid-level NPR30,000-45,000; senior roles over NPR 45,000 + per month. Specialising in UI/UX or motiongraphics further increases value. The demand for remote designers is rising. Platforms likeUpwork, Fiverr, and Behance create global earning opportunities regardless of location.",
                  // "As freelancing and global clients rise, earnings can go much higher."
                ],
                "lists": {
                  "title": "Career Opportunities:",
                  "ul": [
                    "Nepal: NPR 25,000-70,000/month",
                    "Global: Freelance and remote opportunities",
                  ],
                  "ending": ""
                }
              },
              {
                "title": "",
                "content": [
                  // "Scaleup Academy focuses on practical, portfolio-driven learning that prepares you for real projects from day one. Our expert-led training—guided by professionals like our expert mentors with real industry experience (our creative industry professionals)—helps you master:",
                  // "We emphasize hands-on tasks so you graduate with a portfolio strong enough toimpress clients and employers.",
                ],
                "lists": {
                  "title": "Course Highlights / What You Learn:",
                  "ul": [
                    "Adobe Premiere Pro & After Effects",
                    "Color grading, transitions & visual effects",
                    "Motion graphics & animation",
                    "Sound editing & mastering",
                    "Social media & YouTube editing",
                    "Portfolio-ready professional projects"
                  ],
                  "ending": ""
                }
              }
            ]
          },
          {
            "title": "UI/UX Design",
            "sections": [
              {
                "title": "",
                "content": [
                  // "UI/UX Design is the process of creating user-friendly, visually appealing, and meaningful digital experiences. UI (User Interface) focuses on look and layout, while UX (User Experience) ensures that apps and websites are easy to use, intuitive, and enjoyable. Together, they shape how users interact with digital products. Better user experience leads to higher engagement, more sales, and improved customer satisfaction. As businesses in Nepal shift toward digital platforms, UI/UX has become essential.",
                  // "UI designers create the graphical portions of mobile apps, websites, and devices—the elements that a user directly interacts with. Unlike UX, which can apply to just about any product or service, the term UI design applies exclusively to digital products. A UI designer seeks to make apps and websites both visually appealing and easy to navigate. Common tasks of a UI designer include:",
                  // "In Nepal: UI/UX designers earn NPR 50,000–100,000+, with opportunities in fintech, SaaS companies, and digital products.",
                  // "Globally: Remote UI/UX designers are in high demand, with international freelanceplatforms offering competitive project-based earnings",
                  // "At Scaleup Academy, you learn through hands-on, practical projects guided byexpert mentors with real industry experience. You graduate with a completeportfolio of UI/UX case studies ready for employment or freelancing.",
                ],
                "lists": {
                  "title": "Images for Developer:",
                  "ul": [
                    "Hands-on projects",
                    "Expert mentors",
                    "Portfolio creation",
                    "Flexible hybrid learning",
                    "Career and freelancing guidance"
                  ],
                  "ending": ""
                }
              },
              // {
              //   "title": "Career & Future Scope in Graphic Design",
              //   "content": [
              //     "In Nepal, junior graphic designers may earn NPR 15,000-30,000/month; mid-level NPR30,000-45,000; senior roles over NPR 45,000 + per month. Specialising in UI/UX or motiongraphics further increases value. The demand for remote designers is rising. Platforms likeUpwork, Fiverr, and Behance create global earning opportunities regardless of location.",
              //     "As freelancing and global clients rise, earnings can go much higher."
              //   ],
              //   "lists": {
              //     "title": "",
              //     "ul": [
              //     ],
              //     "ending": ""
              //   }
              // },
              // {
              //   "title": "Why Learn Graphic Design at Scaleup Academy?",
              //   "content": [
              //     "Scaleup Academy focuses on practical, portfolio-driven learning that prepares you for real projects from day one. Our expert-led training—guided by professionals like our expert mentors with real industry experience (our creative industry professionals)—helps you master:",
              //     "We emphasize hands-on tasks so you graduate with a portfolio strong enough toimpress clients and employers.",

              //   ],
              //   "lists": {
              //     "title": "",
              //     "ul": [
              //     ],
              //     "ending": ""
              //   }
              // },

            ]
          },
          // {
          //   "title": "Web Development",
          //   "sections": [
          //     {
          //       "title": "Web Development",
          //       "content": [
          //         "Web Development is the process of building websites and web applications that peopleuse daily. It includes frontend development (design & visuals users interact with) andbackend development (servers, logic, and databases that power the system). Together,they create functional, interactive, and responsive digital platforms.",
          //         "Every business-from retail shops to hospitals-needs a modern website to operate andgrow. With digital transformation increasing in Nepal, web development has become atop career choice. Companies rely on developers to create fast, secure, and visuallyappealing websites",
          //         "In Nepal: Developers earn NPR 25,000-80,000+, with higher potential for full-stackdevelopers and those working with modern frameworks.",
          //         "Globally: Remote development jobs and international freelance projects offer strongincome potential, even from Nepal",
          //         "At Scaleup Academy, you learn through hands-on, practical projects guided byexpert mentors with real industry experience. You graduate with a completeportfolio of UI/UX case studies ready for employment or freelancing.",
          //       ],
          //       "lists": {
          //         "title": "At Scaleup Academy we offer project-based learning guided by experienced industryprofessionals. You learn",
          //         "ul": [
          //           "HTML, CSS, JavaScript, React or Vue",
          //           "Backend: Node.js, PHP, Laravel",
          //           "Databases, hosting & deployment",
          //           "Git/GitHub & best coding practices"
          //         ],
          //         "ending": "By the end, you will have real websites and full-stack projects added to your professional portfolio."
          //       },
          //     },

          //     // {
          //     //   "title": "Career & Future Scope in Graphic Design",
          //     //   "content": [
          //     //     "In Nepal, junior graphic designers may earn NPR 15,000-30,000/month; mid-level NPR30,000-45,000; senior roles over NPR 45,000 + per month. Specialising in UI/UX or motiongraphics further increases value. The demand for remote designers is rising. Platforms likeUpwork, Fiverr, and Behance create global earning opportunities regardless of location.",
          //     //     "As freelancing and global clients rise, earnings can go much higher."
          //     //   ]
          //     // },
          //     // {
          //     //   "title": "Why Learn Graphic Design at Scaleup Academy?",
          //     //   "content": [
          //     //     "Scaleup Academy focuses on practical, portfolio-driven learning that prepares you for real projects from day one. Our expert-led training—guided by professionals like our expert mentors with real industry experience (our creative industry professionals)—helps you master:",
          //     //     "We emphasize hands-on tasks so you graduate with a portfolio strong enough toimpress clients and employers.",

          //     //   ]
          //     // }
          //   ]
          // },
          // {
          //   "title": "Digital Marketing",
          //   "sections": [
          //     {
          //       "title": "Digital Marketing",
          //       "content": [
          //         "Digital Marketing is the strategy and practice of promoting products and services through online platforms such as Google, Facebook, Instagram, TikTok, websites, and email. It uses analytics, content, paid ads, and SEO to help brands reach the right audience.",
          //         "As businesses shift to online operations, digital marketing has become essential for visibility and growth. Companies require skilled marketers who understand how to generate leads, run ad campaigns, optimize SEO, and analyze performance.",
          //         "In Nepal: Digital marketers earn NPR 20,000–100,000+, depending on skill level, specialization, and results delivered.",
          //         "Globally: Freelancers and remote digital marketers can work with international brands, earning significantly more.",
          //       ],
          //       "lists": {
          //         "title": "At Scaleup Academy, you learn from expert mentors with real campaign experience.You’ll master:",
          //         "ul": [
          //           "SEO & content marketing",
          //           "Social media strategy (FB, Instagram, TikTok, LinkedIn and more)",
          //           "Meta Ads & Google Ads",
          //           "Analytics & conversion tracking",
          //           "Building full marketing funnels"
          //         ],
          //         "ending": "You graduate ready to work in agencies, companies, or as a freelancer"
          //       }
          //     },

          //   ],


          // },
        ]

        ,
        "whyScaleupAcademy": {
          "heading": "Why Learn at Scaleup Academy, Pokhara",
          "points": [
            "Hybrid Learning: Morning, day, and evening classes (online & onsite).",
            "Practical, project-based learning approach.",
            "Expert mentors from creative and tech industries.",
            "Portfolio development for job and freelance readiness.",
            "Internship, freelancing mentorship, and job placement support.",
            "Community & networking opportunities in Pokhara."
          ],
          "designNote": "Include carousel showcasing different course banners and student experiences."
        },
        "cta": {
          "heading": "Ready to turn your creativity and tech passion into a professional career?",
          "text": "Join the Best Graphic Design, UI/UX, Web Development, and Digital Marketing Courses in Pokhara, Nepal at Scaleup Academy today!",
          "button": "Join Course"
        }
      }
    }


  ]

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop /> {/* ✅ Place this here, not as a wrapper */}
        <Routes >
          <Route path='/' element={<Home CoursesDetails={CoursesDetails} Reviews={Reviews} fullNav={fullNav} blogs={Blogs} />} />
          <Route path='/courses' element={<Cources CoursesDetails={CoursesDetails} fullNav={fullNav} />} />
          <Route path='/course/:id' element={<CoursesPreview CoursesDetails={CoursesDetails} fullNav={fullNav} />} />
          <Route path='/contact' element={<Contact fullNav={fullNav} />} />
          <Route path="/contact/:text" element={<Contact fullNav={fullNav} />} />
          <Route path='/about' element={<About />} />
          <Route path='/blog/:id' element={<BlogPage CoursesDetails={blgCourse} fullNav={true} blogs={Blogs} />} />
          <Route path='/blogs' element={<AllBlog />} />
          <Route path="*" element={<UnderConstruction />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
